import React from 'react';
const SubscriptionContext = React.createContext<any>({
    setSubscriptionInfo: () => {},
});
export default SubscriptionContext;
